import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import {
  crossScreenFontSize,
  crossScreenHeight,
  hoverDefault,
  input,
  toVw,
  toVwMobile,
  toVwTablet,
} from '../utils/styles';
import { FONT_SIZE_TEXT } from '../constants';
import mq from '@/utils/media-queries';

const SUBMIT_TRIANGLE = 'triangle';
const SUBMIT_GO = 'go';
const SUBMIT_NEXT = 'next';
const STATUS_SENT = 'sent';

const PADDING_RIGHT_IF_NEXT = 70;

const Wrapper = styled.span`
  display: inline-block;
  position: relative;

  ${props =>
    props.withNext &&
    css`
      padding-right: ${toVw(PADDING_RIGHT_IF_NEXT)};

      ${mq.tablet(css`
        padding-right: ${toVwTablet(PADDING_RIGHT_IF_NEXT)};
      `)};

      ${mq.mobile(css`
        padding-right: ${toVwMobile(PADDING_RIGHT_IF_NEXT)};
      `)};
    `};
`;

const Input = styled.input`
  ${input};
  padding-right: ${toVw(18)};

  &:focus {
    outline: none;
  }

  ${props =>
    props.height &&
    css`
      ${crossScreenHeight(props.height)};
    `};
`;

const TRIANGLE_WIDTH = 12;
const TRIANGLE_HEIGHT = 18;

const Triangle = styled.button`
  position: absolute;
  right: 0;
  top: 35%;
  margin-top: ${toVw(-TRIANGLE_HEIGHT / 2)};
  width: 0;
  height: 0;
  border: none;
  border-left: ${toVw(TRIANGLE_WIDTH)} solid ${props => props.theme.colorAccent};
  border-top: ${toVw(TRIANGLE_HEIGHT / 2)} solid transparent;
  border-bottom: ${toVw(TRIANGLE_HEIGHT / 2)} solid transparent;
  cursor: pointer;
  -webkit-appearance: none;
  background-color: transparent;
  ${hoverDefault};

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -${toVw(18)};
    right: -${toVw(10)};
    bottom: -${toVw(18)};
    left: -${toVw(20)};
  }

  &:focus {
    outline: none;
  }
`;

const TextAccent = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  color: ${props => props.theme.colorAccent};
  ${crossScreenFontSize(FONT_SIZE_TEXT)};
`;

const Submit = TextAccent.withComponent('button').extend`
	background-color: transparent;
	border: none;
	cursor: pointer;
	${hoverDefault};

	&:focus {
		outline: none;
	}
`;

const Next = styled.span`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0%, -50%);
  color: ${props => props.theme.colorAccent};
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  ${crossScreenFontSize(FONT_SIZE_TEXT)};
  ${hoverDefault};

  ${props =>
    props.visible &&
    css`
      opacity: 1;
      visibility: visible;
    `};
`;

class InputText extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onSubmitClick: PropTypes.func,
    inputRef: PropTypes.func,
    submitType: PropTypes.oneOf([SUBMIT_TRIANGLE, SUBMIT_GO, SUBMIT_NEXT]),
    status: PropTypes.string,
    dataTest: PropTypes.string,
    value: PropTypes.string,
    onNextClick: PropTypes.func,
    hideNext: PropTypes.bool,
    height: PropTypes.number,
  };

  state = {
    sent: false,
  };

  componentDidMount() {
    this.props.inputRef && this.props.inputRef(this.inputNode);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.status !== this.props.status && nextProps.status === STATUS_SENT) {
      this.setState({ showSent: true });
      setTimeout(() => this.setState({ showSent: false }), 5000);
    }
  }

  render() {
    const {
      className,
      submitType,
      onSubmitClick,
      dataTest,
      value,
      onNextClick,
      hideNext,
      height,
      ...rest
    } = this.props;

    return (
      <Wrapper className={className} data-test={dataTest} withNext={submitType === SUBMIT_NEXT}>
        <Input type="text" value={value} height={height} {...rest} innerRef={node => (this.inputNode = node)} />
        {submitType === SUBMIT_TRIANGLE && <Triangle onClick={onSubmitClick} data-test="input-submit" />}
        {submitType === SUBMIT_GO && (this.state.showSent ? <TextAccent>готово!</TextAccent> : <Submit>Ок</Submit>)}
        {submitType === SUBMIT_NEXT && (
          <Next visible={!!value && !hideNext} onClick={onNextClick}>
            далее
          </Next>
        )}
      </Wrapper>
    );
  }
}

export default InputText;



// WEBPACK FOOTER //
// ./src/components/InputText.js